import { render } from "./CompanyView.vue?vue&type=template&id=074914af"
import script from "./CompanyView.vue?vue&type=script&lang=js"
export * from "./CompanyView.vue?vue&type=script&lang=js"

import exportComponent from "/home/vovan/Документы/Projects/taho-crm-git/Taho-Front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__